import styled from 'styled-components';

const TrusteeItemStyle = styled.section`
	--trusteeWrapperRadiusSize: var(--sp2-5x);
	--trusteeWrapperPad: var(--sp1-5x) var(--sp1-5x) var(--sp3x) var(--sp1-5x);
	--trusteeTextMargin: var(--sp3x) var(--sp3x) 0 var(--sp3x);
	--distance: var(--sp2x) 0 var(--sp4x);
	--trusteeImageRadiusSize: var(--sp2x);
	--trusteeImageSize: 110%;

	height: 100%;

	.truster-wrapper {
		border-radius: var(--trusteeWrapperRadiusSize);
		padding: var(--trusteeWrapperPad);
		background-color: var(--gray100);
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		transition: background-color var(--trTime) ease-out;
	}

	.trustee-name {
		word-wrap: break-word;
	}

	.text-wrapper {
		margin: var(--trusteeTextMargin);
		height: 100%;
	}

	.trustee-position {
		margin: var(--distance);
	}

	.trustee-img {
		--proportion: var(--trusteeImageSize);

		img {
			transition: all var(--trTime) ease-out !important;
		}

		overflow: hidden;
		border-radius: var(--trusteeImageRadiusSize);
	}

	@media (pointer: fine) {
		@media (hover: hover) {
			&:hover {
				img {
					transform: scale(1.1);
				}

				.truster-wrapper {
					background-color: var(--gray200);
				}
			}
		}
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--trusteeWrapperRadiusSize: var(--sp2-5x);
		--trusteeWrapperPad: var(--sp1x) var(--sp1x) var(--sp3x) var(--sp1x);
		--trusteeTextMargin: var(--sp2x) var(--sp2x) 0 var(--sp2x);
		--distance: var(--sp1x) 0 var(--sp3x);
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--trusteeWrapperRadiusSize: var(--sp2-5x);
		--trusteeWrapperPad: var(--sp1x) var(--sp1x) var(--sp2x) var(--sp1x);
		--trusteeTextMargin: var(--sp2x) var(--sp1-5x) 0 var(--sp1-5x);
		--distance: var(--sp1-5x) 0 var(--sp2x);
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--trusteeWrapperRadiusSize: var(--sp2x);
		--trusteeWrapperPad: var(--sp1x) var(--sp1x) var(--sp2x) var(--sp1x);
		--trusteeTextMargin: var(--sp2x) var(--sp1x) 0 var(--sp1x);
		--distance: var(--sp1x) 0 var(--sp1x);
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--trusteeWrapperRadiusSize: var(--sp2-5x);
		--trusteeWrapperPad: var(--sp1x) var(--sp1x) var(--sp1-5x) var(--sp1x);
		--trusteeTextMargin: var(--sp1-5x) var(--sp1x) 0 var(--sp1x);
		--distance: var(--sp1x) 0 var(--sp2x);
	}

	/* //! 1024 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--trusteeWrapperRadiusSize: var(--sp2x);
		--trusteeWrapperPad: var(--sp0-5x) var(--sp0-5x) var(--sp2x) var(--sp0-5x);
		--trusteeTextMargin: var(--sp1-5x) var(--sp1x) 0 var(--sp1x);
		--distance: var(--sp1x) 0 var(--sp1-5x);
		--trusteeImageRadiusSize: var(--sp1-5x);
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeXMin}) {
		--trusteeWrapperRadiusSize: var(--sp1x);
		--trusteeWrapperPad: var(--sp0-5x) var(--sp0-5x) var(--sp1x) var(--sp0-5x);
		--trusteeTextMargin: var(--sp1x) var(--sp0-5x) 0 var(--sp0-5x);
		--distance: var(--sp0-5x) 0 var(--sp1-5x);
		--trusteeImageRadiusSize: var(--sp0-5x);
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--trusteeWrapperRadiusSize: var(--sp1x);
		--trusteeWrapperPad: var(--sp0-5x) var(--sp0-5x) var(--sp2x) var(--sp0-5x);
		--trusteeTextMargin: var(--sp1-5x) var(--sp1x) 0 var(--sp1x);
		--distance: var(--sp1x) 0 var(--sp1-5x);
		--trusteeImageRadiusSize: var(--sp0-5x);
	}
`;

export default TrusteeItemStyle;
